import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";

import "./navbar.css";
import Logo from "../../assets/images/logo.png";

function Navbar() {
  const location = useLocation();
  const [isNavCollapsed, setIsNavCollapsed] = useState(true);

  const handleNavCollapse = () => setIsNavCollapsed(!isNavCollapsed);

  useEffect(() => {
    AOS.init({
      duration: 800,
      once: true,
    });
  }, []);

  return (
    <header className="sticky-top header-site">
      <nav className="navbar navbar-expand-lg navbar-dark px-3 px-xl-5 navbar-personalizada">
        <div className="container-fluid">
          <Link
            className="navbar-brand d-flex flex-column align-items-center"
            to="/"
            aria-label="Antonio Saldanha Advocacia - Página Inicial"
            data-aos="fade-right"
            data-aos-duration="600"
          >
            <img
              src={Logo}
              alt="Logo Antonio Saldanha Advocacia"
              className="logo-navbar"
            />
          </Link>

          <button
            className="navbar-toggler ms-auto"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded={!isNavCollapsed}
            aria-label="Alternar navegação"
            onClick={handleNavCollapse}
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div
            className={`${isNavCollapsed ? "collapse" : ""} navbar-collapse`}
            id="navbarSupportedContent"
          >
            <ul className="navbar-nav ms-auto align-items-lg-center gap-lg-1">
              <li className="nav-item">
                <Link
                  className={`nav-link text-white ${location.pathname === "/" && !location.hash ? "active-link" : ""}`}
                  to="/"
                  onClick={() => setIsNavCollapsed(true)}
                >
                  Home
                </Link>
              </li>

              <li className="nav-separator d-none d-lg-block">•</li>

              <li className="nav-item">
                <Link
                  className={`nav-link text-white ${location.pathname === "/sobre-nos" ? "active-link" : ""}`}
                  to="/sobre-nos"
                  onClick={() => setIsNavCollapsed(true)}
                >
                  Sobre Nós
                </Link>
              </li>

              <li className="nav-separator d-none d-lg-block">•</li>

              <li className="nav-item">
                <Link
                  className={`nav-link text-white ${location.pathname === "/o-escritorio" ? "active-link" : ""}`}
                  to="/o-escritorio"
                  onClick={() => setIsNavCollapsed(true)}
                >
                  O Escritório
                </Link>
              </li>

              <li className="nav-separator d-none d-lg-block">•</li>

              <li className="nav-item">
                <Link
                  className={`nav-link text-white ${location.pathname === "/nossa-equipe" ? "active-link" : ""}`}
                  to="/nossa-equipe"
                  onClick={() => setIsNavCollapsed(true)}
                >
                  Nossa Equipe
                </Link>
              </li>

              <li className="nav-separator d-none d-lg-block">•</li>

              <li className="nav-item">
                <Link
                  className="nav-link text-white"
                  to="/#areas"
                  onClick={() => setIsNavCollapsed(true)}
                >
                  Áreas de Atuação
                </Link>
              </li>

              <li className="nav-separator d-none d-lg-block">•</li>

              <li className="nav-item">
                <Link
                  className="nav-link text-white"
                  to="/#contato"
                  onClick={() => setIsNavCollapsed(true)}
                >
                  Fale Conosco
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </header>
  );
}

export default Navbar;
